__turbopack_context__.v({
  "brush-stroke": "style-module-scss-module__Ru1fZG__brush-stroke",
  "brush-stroke-1": "style-module-scss-module__Ru1fZG__brush-stroke-1",
  "brush-stroke-2": "style-module-scss-module__Ru1fZG__brush-stroke-2",
  "choice": "style-module-scss-module__Ru1fZG__choice",
  "choices": "style-module-scss-module__Ru1fZG__choices",
  "component": "style-module-scss-module__Ru1fZG__component",
  "content": "style-module-scss-module__Ru1fZG__content",
  "disclaimer": "style-module-scss-module__Ru1fZG__disclaimer",
  "outside": "style-module-scss-module__Ru1fZG__outside",
  "wrapper": "style-module-scss-module__Ru1fZG__wrapper",
});
